module.exports = __webpack_public_path__ + "static/NimbusSanL-Bold-30c2b552e30a71d7ca10ff0df9b7d5d5.woff";